import React from 'react';

export default function CommonInput({
    label,
    labelClassName = '',
    id,
    value,
    testId,
    onChange,
    type = 'text',
    placeholder = '',
    error = false,
    errorMessage = '',
    disabled = false,
    maxLength,
    max,
    className = '',
}) {
    return (
        <div className={`${className}`}>
            <label
                htmlFor={id}
                className={`font-medium leading-normal ${
                    error ? 'text-[#984848]' : disabled ? 'text-[#A1A1A9]' : 'text-[#343434]'
                } ${labelClassName || ''}`}
            >
                {label}
            </label>

            <input
                id={id}
                data-testid={testId}
                type={type}
                value={value}
                autoComplete="off"
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                max={max}
                maxLength={maxLength}
                className={`text-[14px] w-full py-3 px-3 border outline-none font-medium leading-normal
                    ${disabled ? 'bg-white text-[#A1A1A9]' : 'text-[#343434]'}
                    ${error ? 'border-[#984848]' : 'border-[#A1A1A9]'}
                `}
            />

            {error && errorMessage && (
                <p className="text-[10px] pt-1 font-medium leading-normal text-[#984848]">
                    {errorMessage}
                </p>
            )}
        </div>
    );
}
